import { IConfig } from '@unleash/proxy-client-react'

export const config: IConfig = {
  url: process.env.REACT_APP_UNLEASH_FF_PROXY!, // FE API URL or the Unleash proxy's URL
  clientKey: 'proxy-client-key', // proxy's designated client public key
  refreshInterval: 60, // How often (in seconds) the client should poll the proxy for updates
  appName: 'backbone-platform', // it's only used for identifying application
}
